import classNames from "classnames"

import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import { getBackgroundColorClass } from "@utils/V2/color"
import React, { ReactNode } from "react"

type Props = {
  icon: ReactNode | string
  text: string
  variant?: "light" | "dark"
  highlightedText?: string
}

const IconBadge = ({
  icon,
  text,
  variant = "dark",
  highlightedText,
}: Props) => {
  return (
    <div
      className={classNames(
        getBackgroundColorClass(
          variant === "dark" ? Color.Coal : Color.LightGray
        ),
        "flex items-center gap-[6px] rounded-8 px-8 py-[6px]"
      )}
    >
      {typeof icon === "string" ? (
        <img src={icon} width={20} height={20} />
      ) : (
        icon
      )}
      <Typography
        text={text}
        color={variant === "dark" ? Color.White : Color.Black}
        size="body-sm-fixed"
        font="grotesk"
        weight="book"
        className="text-nowrap"
        highlightedText={highlightedText}
        highlightColor={Color.Black}
        highlightWeight="medium"
      />
    </div>
  )
}

export default IconBadge
